/* eslint-disable camelcase */
/* eslint-disable @stylistic/quote-props */
/* eslint-disable @stylistic/padded-blocks */
function set_fancybox ($elem, $extra_opts) {
  var opts = {
    openEffect: 'elastic',
    closeEffect: 'elastic',
    beforeShow: function () {
      $('body').css({ 'overflow-y': 'hidden' });
    },
    afterClose: function () {
      $('body').css({ 'overflow-y': 'visible' });
    },
    helpers: {
      overlay: {
        locked: false,
        css: {
          'background': 'rgba(171, 200, 237, 0.6)'
        }
      }
    }
  };
  $.each($extra_opts, function (k, v) {
    if (k === 'helpers') {
      $.each(v, function (helper_opt, helper_vals) {
        opts.helpers[helper_opt] = helper_vals;
      });
    } else {
      opts[k] = v;
    }
  });
  $elem.fancybox(opts);
}

$(document).ready(function () {
  'use strict';

  set_fancybox($('.lowPriceGtyLink'), {
    width: 640,
    height: 248
  });

  set_fancybox($('.fullIframe'), {
    width: '95%',
    height: '95%'
  });

  set_fancybox($('a.checkUsOutPop'), {
    width: 450,
    height: 300
  });

  $('a.cruiselineOverview, a.cruiseshipOverview, a.tourOverview, a.resortbrandOverview').each(function () {
    set_fancybox($(this), {
      maxWidth: 540,
      maxHeight: 360,
      helpers: {
        title: {
          type: 'inside'
        }
      },
      title: $(this).attr('title')
    });
  });

  set_fancybox($('a.insideTitleFancybox'), {
    maxWidth: 540,
    maxHeight: 360,
    helpers: {
      title: {
        type: 'inside'
      }
    }
  });

  set_fancybox($('.admin_cruiselines_fancybox'), {
    maxWidth: 1150,
    maxHeight: 550
  });

  set_fancybox($('.admin_resort-brands_fancybox'), {
    maxWidth: 1150,
    maxHeight: 550
  });

  set_fancybox($('.cruise_lines_fancybox'), {});

  set_fancybox($('.adc_fancybox'), {
    helpers: {
      title: {
        type: 'inside'
      }
    }
  });

  set_fancybox($('.ship_slides_fancybox,.image_slides_fancybox'), {
    maxWidth: 750,
    maxHeight: 542,
    helpers: {
      title: {
        type: 'inside'
      }
    },
    beforeShow: function () {
      this.title = $(this.element).attr('data-title');
    }
  });

  set_fancybox($('.ros_deals_fancybox'), {
    maxWidth: 750,
    maxHeight: 542,
    minWidth: 300
  });

  set_fancybox($('.gallery-fancybox'), {
    autoSize: true,
    fitToView: false,
    autoDimensions: true,
    afterShow: function () {
      if (window.ResizeObserver) {
        const el = document.querySelector(this.href);
        const ro = new ResizeObserver(function () {
          $.fancybox.update();
          $.fancybox.reposition();
        });
        ro.observe(el);

        this._resizeObserver = ro;
      }
    },

    beforeClose: function () {
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
    }
  });

  set_fancybox($('.fancybox'), {});
  set_fancybox($('.ship_calendar_fancybox'), {
    minWidth: '1025px',
    minHeight: 'auto'
  });
  set_fancybox($('.vendorVideo'), {});
  set_fancybox($('.resortListPricing'), {
    minWidth: '1025px',
    minHeight: '650px'
  });
  set_fancybox($('#portDirectionBtn,.portDirectionBtn'), {});

});
